module.exports = __webpack_public_path__ + "static/media/memberpix1.42fbb21c.jpg";